import React from 'react';
import PropTypes from 'prop-types';

import { IRON } from '@constant/colors';

const TransferError = ({ circle, className, color }) => (
  <svg className={className} viewBox="55 42 171 171">
    <g fill="none" fillRule="evenodd">
      {circle ? (
        <path
          fill={color}
          d="M200.104 66.896c33.195 33.194 33.195 87.014 0 120.208-33.194 33.195-87.014 33.195-120.208 0-33.195-33.194-33.195-87.014 0-120.208 33.194-33.195 87.014-33.195 120.208 0zm-7.07 7.07c29.288 29.29 29.288 76.778 0 106.067-29.29 29.29-76.778 29.29-106.067 0-29.29-29.29-29.29-76.777 0-106.066 29.29-29.29 76.777-29.29 106.066 0z"
        />
      ) : null}
      <path
        fill={color}
        d="M136.75 141.407h7.432l3.315-29.634V92.887h-14.164v18.886l3.416 29.634zM133.734 162h13.36v-13.26h-13.36V162z"
      />
    </g>
  </svg>
);

TransferError.propTypes = {
  circle: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
};

TransferError.defaultProps = {
  circle: true,
  color: IRON,
};

export default TransferError;
